import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
import { SlOptionsVertical } from 'react-icons/sl';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';

function ModalObterCapacidade({ setModal }) {

    const { ObterCapacidade, CapacidadeObter, setCapacidadeObter, CapacidadeAtualKey, RetornaSistemaCapacidade, CapacidadeSistema, ListaServicoCapacidade, CapacidadeServico, } = useContext(ApiContext)
    const { h3Demanda } = useContext(StyleContext);
    const [carregado, setCarregado] = useState(false);

    useEffect(() => {
        setCapacidadeObter(null);
        setCarregado(false);
        if (CapacidadeAtualKey) {
            ObterCapacidade(CapacidadeAtualKey).catch(() => { }).finally(() => setCarregado(true));
        } else {
            setCarregado(true);
        }
        return () => setCapacidadeObter(null);
    }, [CapacidadeAtualKey])

    useEffect(() => {
        RetornaSistemaCapacidade()
        ListaServicoCapacidade()
    }, [])

    return (
        <>
            <div className="modal-novo">
                <div className="modal-novo-interno">
                    <div className="header-modal">
                        <div>
                            <h1 className="h1-modal">Detalhes da capacidade</h1>
                        </div>
                        <div className="btn-close-modal" onClick={() => setModal(false)}>
                            <FaTimes />
                        </div>
                    </div>
                    <div className="modal-content">
                        <form className="mb-3">
                            {!carregado ? (
                                <div className="span-bsc" style={{ padding: 20 }}>Carregando...</div>
                            ) : (
                            <Tabs className='mt-3 mb-3'>
                                <Tab eventKey="capacidades" title={<span>Capacidade</span>}>
                                    <Row>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control readOnly defaultValue={CapacidadeObter?.titulo} />
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Col xs={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nível</Form.Label>
                                                <Form.Control readOnly defaultValue={CapacidadeObter?.nivel} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Capacidade de Negócio Pai</Form.Label>
                                                <Form.Control readOnly defaultValue={CapacidadeObter?.capacidadeNegocioDemandaPai?.titulo} />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Label>Área</Form.Label>
                                            <Form.Control readOnly defaultValue={CapacidadeObter?.area?.descricao} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control as="textarea" rows={3} readOnly defaultValue={CapacidadeObter?.descricao} />
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Label>Business Owner</Form.Label>
                                            <Form.Control readOnly defaultValue={CapacidadeObter?.pessoa?.nome} />
                                        </Col>
                                        <Col>
                                            <Form.Label>Arquiteto corporativo</Form.Label>
                                            <Form.Control readOnly defaultValue={CapacidadeObter?.arquiteto?.nome} />
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Relevância</Form.Label>
                                                <Form.Control readOnly defaultValue={CapacidadeObter?.relevancia} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="sistemas" title={<span>Aplicações</span>}>
                                    <h3 className='h3-demanda' style={h3Demanda}>Aplicações vinculadas</h3>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className='titulo-fases'>Aplicação</th>
                                                <th className='titulo-fases'>Fornecedor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {CapacidadeSistema && CapacidadeSistema.length > 0 ? (
                                                CapacidadeSistema.map((item, index) => (
                                                    <tr key={index} className='titulo-fases'>
                                                        <td>{item?.nome}</td>
                                                        <td>{item?.fornecedor?.fantasia}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className='titulo-fases' colSpan="2">Nenhuma capacidade disponível</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Tab>
                                <Tab eventKey="servicos" title={<span>Serviços</span>}>
                                    <h1 className='h1-modal'>Serviços</h1>
                                    <hr />
                                    <Row>
                                        <div style={{ height: '30vh', width: '100%', overflow: 'auto' }}>
                                            {CapacidadeServico && CapacidadeServico.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <div key={index} className="content-comentario">
                                                            <div className="div-comentario">
                                                                <SlOptionsVertical style={{ marginRight: '15px' }} className='titulo-fases' />
                                                                <p className='titulo-fases'>{item.servico.descricao}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Row>
                                </Tab>
                                <Tab eventKey="mapacalor" title={<span>Mapa de Calor</span>}>
                                    {!CapacidadeObter?.dominio &&
                                        <>
                                            <Row>
                                                <Col xs={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tipo da Capacidade</Form.Label>
                                                        <Form.Control
                                                            readOnly
                                                            defaultValue={
                                                                CapacidadeObter?.tipoCapacidade === 1
                                                                    ? "Estratégica"
                                                                    : CapacidadeObter?.tipoCapacidade === 2
                                                                        ? "Tática"
                                                                        : CapacidadeObter?.tipoCapacidade === 3
                                                                            ? "Operacional"
                                                                            : "Sem tipo de capacidade"
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {['checkbox'].map((type) => (
                                                    <div key={`inline-${type}`} className="mb-3">
                                                        <Form.Check
                                                            inline
                                                            label="Rodar"
                                                            name="rodar"
                                                            type={type}
                                                            id={`inline-${type}-1`}
                                                            checked={CapacidadeObter?.rodar}
                                                            disabled
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Crescer"
                                                            name="crescer"
                                                            type={type}
                                                            id={`inline-${type}-2`}
                                                            checked={CapacidadeObter?.crescer}
                                                            disabled
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Transformar"
                                                            name="transformar"
                                                            type={type}
                                                            id={`inline-${type}-3`}
                                                            checked={CapacidadeObter?.transformar}
                                                            disabled
                                                        />
                                                    </div>
                                                ))}
                                            </Row>
                                        </>
                                    }
                                </Tab>
                            </Tabs>
                            )}
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalObterCapacidade